import { useRef, useState } from 'react';

import { Box, Divider, Menu } from '@mui/material';

import { MenuModulesNodeList } from 'components/header/menu-modules/desktop/MenuModulesNodeList';
import { MenuModulesButton } from 'components/header/menu-modules/MenuModulesButton';
import { MenuModulesSearchField } from 'components/header/menu-modules/MenuModulesSearchField';
import { MenuModulesSearchResults } from 'components/header/menu-modules/MenuModulesSearchResults';
import { MenuNode } from 'components/header/menu-modules/types';

type MenuModulesDesktop = {
    menuNodes: MenuNode[];
    flatNodes: MenuNode[];
};

/**
 * MenuModulesDesktop
 * └── [search input]
 *     ├── (query) → MenuModulesSearchResults — lista plana com breadcrumb
 *     └── (sem query) → MenuModulesNodeList
 *         ├── MenuModulesItem      (node sem filhos → navega ao clicar)
 *         └── MenuModulesSubmenu   (node com filhos → abre submenu no hover)
 *             └── MenuModulesNodeList  (recursivo)
 */
export function MenuModulesDesktop({ menuNodes, flatNodes }: MenuModulesDesktop) {
    const [anchor, setAnchor] = useState<HTMLElement | null>(null);
    const [query, setQuery] = useState('');
    const inputRef = useRef<HTMLInputElement>(null);

    /**
     * Fecha o menu e limpa o campo de busca.
     */
    const handlerClose = () => {
        setAnchor(null);

        // delay para nao limpar o campo de busca até esconder o menu completamente
        setTimeout(() => setQuery(''), 200);
    };

    return (
        <>
            <MenuModulesButton onClick={(e) => setAnchor(e.currentTarget)} />

            <Menu
                anchorEl={anchor}
                open={Boolean(anchor)}
                onClose={handlerClose}
                slotProps={{
                    paper: { elevation: 3, sx: { width: 270 } },
                    list: { sx: { p: 0 } },
                    transition: { onEntered: () => inputRef.current?.focus() },
                }}
            >
                <Box sx={{ m: 1 }}>
                    <MenuModulesSearchField query={query} setQuery={setQuery} ref={inputRef} />
                </Box>

                <Divider />

                <Box sx={{ maxHeight: 480, overflowY: 'auto' }}>
                    {query.trim().length < 2 && <MenuModulesNodeList nodes={menuNodes} onClose={handlerClose} />}

                    {query.trim().length >= 2 && <MenuModulesSearchResults query={query} flatNodes={flatNodes} onClose={handlerClose} />}
                </Box>
            </Menu>
        </>
    );
}
